import { render, staticRenderFns } from "./Alignment.vue?vue&type=template&id=9e32d1da"
import script from "./Alignment.vue?vue&type=script&lang=js"
export * from "./Alignment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports